// extracted by mini-css-extract-plugin
module.exports = {"tag":"amountTag_tag__1D5cA","num":"amountTag_num__1Taqp"};